import React, { useContext, useState, useEffect } from "react";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import { GlobalState } from "./Globalstate";
import Users from "./Pages/Users";
import Dashboard from "./Pages/Dashboard";
import Deposits from "./Pages/Deposits";
import Investments from "./Pages/Investments";
import Withdrawal from "./Pages/Withdrawal";
import Login from "./Login";
import Sitesettings from "./Pages/SiteSettings";
import SendMail from "./Pages/SendMail";
import AdminCompoundInvest from "./Pages/compoundingplan";
import WalletSettings from "./Pages/WalletSettings";
import AdminReferrals from "./Pages/Refferals";

import "./App.css"

function App() {
  return (
    <>
      <GlobalState>
        <BrowserRouter>
          <Routes>

            <Route exact path="/" element={<Dashboard />} />
            <Route exact path="/users" element={<Users />} />
            <Route exact path="/deposits" element={<Deposits />} />
            <Route exact path="/withdrawals" element={<Withdrawal />} />
            <Route exact path="/investments" element={<Investments />} />
             <Route exact path="/cmdinvestments" element={<AdminCompoundInvest/>} />
            <Route exact path="/Settings" element={<Sitesettings />} />
             <Route exact path="/sendmail" element={<SendMail />} />
                <Route exact path="/walletsettings" element={<WalletSettings />} />
            <Route exact path="/referrals" element={<AdminReferrals />} />
            <Route exact path="/login" element={<Login />} />
          </Routes>
        </BrowserRouter>
      </GlobalState>
    </>
  );
}

export default App;
